// imports
import React from 'react';
import ItemList from '../../molecules/list/item';

// exports
export default function ItemCollection(): JSX.Element {
  return (<ItemList />);
}
